


import React, { useEffect } from "react";
import Layout from "../../utils/layout";
import { Link, useNavigate } from "react-router-dom";
import useStore from "../../hooks/useStore";
import { observer } from "mobx-react";
import { useAuth } from "../../context/authProvider";

const CompanyList = () => {
  const navigate = useNavigate();
  const {
    companyStore: { getCompanyData, companiesList },
  } = useStore();

  const { token } = useAuth();
  const [deletingId, setDeletingId] = React.useState(null);

  const handleStatusChange = async (companyId, newStatus) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${token}`);
    const raw = JSON.stringify({ companyId, status: newStatus });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    await fetch(
      `${process.env.REACT_APP_BASE_URL}company/update-status`,
      requestOptions
    );
    getCompanyData(); // Refresh list after update
  };



//   const handleDeleteCompany = async (companyId) => {
//   if (!companyId) {
//     alert("No company Id found");
//     return;
//   }
  
//   // Prevent multiple clicks by setting deletingId BEFORE confirmation
//   if (deletingId === companyId) {
//     return; // Already processing this company
//   }
  
//   const confirmed = window.confirm("Are you sure you want to delete this company?");
//   if (!confirmed) return;
  
//   setDeletingId(companyId); // Set loading state
  
//   try {
//     const myHeaders = new Headers();
//     myHeaders.append("Content-Type", "application/json");
//     myHeaders.append("Authorization", `Bearer ${token}`);

//     const raw = JSON.stringify({ companyId });

//     const requestOptions = {
//       method: "DELETE",
//       headers: myHeaders,
//       body: raw,
//       redirect: "follow",
//     };

//     const response = await fetch(
//       `${process.env.REACT_APP_BASE_URL}company/delete-by-company-id`,
//       requestOptions
//     );
    
//     if (!response.ok) {
//       const errorText = await response.text();
//       console.error("Delete company error:", response.status, errorText);
//       alert(`Delete failed: ${response.status} - ${errorText}`);
//     } else {
//       const result = await response.json();
//       console.log("Delete company success:", result);
//       await getCompanyData(); // Refresh list after delete
//     }
//   } catch (err) {
//     console.error("Delete company fetch error:", err);
//     alert("Delete failed: " + err.message);
//   } finally {
//     setDeletingId(null);
//   }
// };

  const handleDeleteCompany = async (companyId) => {
    if (!companyId) {
      alert("No company Id found");
      return;
    }
    const confirmed = window.confirm("Are you sure you want to delete this company?");
    if (!confirmed) return;
    setDeletingId(companyId);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${token}`);

      const raw = JSON.stringify({ companyId });

      const requestOptions = {
        method: "DELETE",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}company/delete-by-company-id`,
        requestOptions
      );
      if (!response.ok) {
        const errorText = await response.text();
        console.error("Delete company error:", response.status, errorText);
        alert(`Delete failed: ${response.status} - ${errorText}`);
      } else {
        const result = await response.json();
        console.log("Delete company success:", result);
        await getCompanyData(); // Refresh list after delete
      }
    } catch (err) {
      console.error("Delete company fetch error:", err);
      alert("Delete failed: " + err.message);
    } finally {
      setDeletingId(null);
    }
  };

  const tablehead = [
    "First Name",
    "Last Name",
    "Email",
    "Phone Number",
    "Employee Range",
    "Company Name",
    "Region",
    "Industry",
    "Allowed Employee",
    "Address",
    "Toggle",
    "Status",
    "Action",
    "Delete",
  ];

  useEffect(() => {
    getCompanyData();
    console.log(getCompanyData);
  }, [getCompanyData]);

  return (
    <Layout>
      <div className="categories">
        <div className="container-fluid">
          {/* Page Title */}
          <div className="row">
            <div className="col-12">
              <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 className="mb-sm-0 font-size-18">Companies</h4>
                <div className="page-title-right">
                  <ol className="breadcrumb m-0">
                    <li className="breadcrumb-item">
                      <Link to="/admin/dashboard">Home</Link>
                    </li>
                    <li className="breadcrumb-item active">Companies</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          {/* End Page Title */}
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="row mb-2">
                    <div className="col-sm-4">
                      <div className="search-box me-2 mb-2 d-inline-block">
                        <div className="position-relative">
                          <input
                            type="text"
                            className="form-control"
                            id="searchTableList"
                            placeholder="Search..."
                          />
                          <i className="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-8">
                      <div className="text-sm-end">
                        <Link to={"/admin/add-company"}>
                          <button
                            type="button"
                            data-bs-toggle="modal"
                            data-bs-target="#newCustomerModal"
                            className="btn btn-success waves-effect waves-light mb-2 me-2 addCustomers-modal"
                          >
                            <i className="mdi mdi-plus me-1"></i> New Company
                          </button>
                        </Link>
                      </div>
                    </div>
                  </div>

                  <div className="table-responsive table-wrap">
                    <table className="table align-middle table-bordered table-nowrap mb-0">
                      <thead>
                        <tr>
                          <th>Sr. No.</th>
                          {tablehead?.map((item, index) => (
                            <th key={index}>{item}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {companiesList?.map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item?.firstName}</td>
                            <td>{item?.lastName}</td>
                            <td>{item?.email}</td>
                            <td>{item?.phoneNumber}</td>
                            <td>{item?.employeeRange}</td>
                            <td>{item?.companyName}</td>
                            <td>{item?.region}</td>
                            <td>{item?.industry}</td>
                            <td>{item?.allowedEmployee}</td>
                            <td>{item?.address}</td>
                            <td>
                              {/* Toggle switch for status */}
                              <label className="switch">
                                <input
                                  type="checkbox"
                                  checked={item.status === true}
                                  onChange={(e) =>
                                    handleStatusChange(
                                      item.id,
                                      e.target.checked
                                    )
                                  }
                                />
                                <span className="slider round"></span>
                              </label>
                            </td>
                            <td>
                              <span
                                style={{
                                  color: item?.status ? "green" : "red",
                                  fontWeight: "bold",
                                }}
                              >
                                {item?.status ? "Active" : "Inactive"}
                              </span>
                            </td>
                            <td>
                              <button
                                className="btn btn-primary btn-sm btn-action waves-effect waves-light me-2"
                                onClick={() =>
                                  navigate("/admin/add-company", {
                                    state: item,
                                  })
                                }
                              >
                                <i className="mdi mdi-pencil font-size-14"></i>{" "}
                                Edit
                              </button>
                            </td>
                           <td>
  <button
    className="btn btn-action waves-effect waves-light"
    title="Delete Company"
    onClick={() => handleDeleteCompany(item.id)}
    disabled={deletingId === item.id} // Disable when processing
    style={{ 
      background: 'none', 
      border: 'none', 
      padding: 0, 
      cursor: deletingId === item.id ? 'not-allowed' : 'pointer',
      opacity: deletingId === item.id ? 0.5 : 1
    }}
  >
    {deletingId === item.id ? (
      <i className="mdi mdi-loading mdi-spin" style={{ fontSize: '20px', color: '#d32f2f' }}></i>
    ) : (
      <i className="mdi mdi-delete-outline" style={{ fontSize: '20px', color: '#d32f2f' }}></i>
    )}
  </button>
</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {/* CSS for toggle switch */}
                  <style>{`
                    .switch {
                      position: relative;
                      display: inline-block;
                      width: 40px;
                      height: 24px;
                    }
                    
                    .switch input {
                      opacity: 0;
                      width: 0;
                      height: 0;
                    }
                    
                    .slider {
                      position: absolute;
                      cursor: pointer;
                      top: 0;
                      left: 0;
                      right: 0;
                      bottom: 0;
                      background-color: #ccc;
                      -webkit-transition: .4s;
                      transition: .4s;
                      border-radius: 24px;
                    }
                    
                    .slider:before {
                      position: absolute;
                      content: "";
                      height: 18px;
                      width: 18px;
                      left: 3px;
                      bottom: 3px;
                      background-color: white;
                      -webkit-transition: .4s;
                      transition: .4s;
                      border-radius: 50%;
                    }
                    
                    input:checked + .slider {
                      background-color: #4caf50;
                    }
                    
                    input:focus + .slider {
                      box-shadow: 0 0 1px #4caf50;
                    }
                    
                    input:checked + .slider:before {
                      -webkit-transform: translateX(16px);
                      -ms-transform: translateX(16px);
                      transform: translateX(16px);
                    }
                  `}</style>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default observer(CompanyList);